import * as React from 'react';
import * as classNames from 'classnames';

export enum FontSize {
    FourX = 'fa-4x',
    TwoX = 'fa-2x',
    OneX = 'fa-1x',
}

interface LoadingProps {
    size?: FontSize;
    className?: string;
    style?: React.CSSProperties;
}

export default class Loading extends React.Component<LoadingProps> {
    static defaultProps = {
        size: FontSize.FourX,
        className: 'text-center text-info',
    }

    constructor(props: LoadingProps) {
        super(props);
    }

    render() {
        const classes = classNames('fas', 'fa-circle-notch', 'fa-spin', 'text-info', this.props.size);

        return (
            <div className={this.props.className} style={this.props.style}>
                <i className={classes}></i>
                <div>{this.props.children}</div>
            </div>
        );
    }
}
